import { clientConfigSchema, type ClientConfig } from "@libs/aigon-api/clientConfig.js";
import { apiOrigin } from "./apiOrigin.js";

export async function fetchClientConfig(): Promise<ClientConfig> {
	const response = await fetch(`${apiOrigin}/client-config`);
	if (!response.ok) {
		throw new Error(`Failed to fetch client config: unexpected response status ${response.status}`);
	}
	return clientConfigSchema.parse(await response.json());
}
